module.exports = __webpack_public_path__ + "static/img/Bradley-Clyde.8ceb914.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bradley-Clyde.jpg
// module id = iOqF
// module chunks = 0